import _classCallCheck from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { ArgumentNullError } from "./Error";
import { EventSource } from "./EventSource";
export var Events = /*#__PURE__*/function () {
  function Events() {
    _classCallCheck(this, Events);
  }

  _createClass(Events, null, [{
    key: "instance",
    get: function get() {
      return Events.privInstance;
    }
  }]);

  return Events;
}();
Events.privInstance = new EventSource();

Events.setEventSource = function (eventSource) {
  if (!eventSource) {
    throw new ArgumentNullError("eventSource");
  }

  Events.privInstance = eventSource;
};